import rules from '../constants/businessRules/businessRules';

const items = {
    IMAGE: {
        content: {
            href: '',
            src: 'PLACE_HOLDER',
            mimetype: '',
            aspectRatio: null,
            alt: '',
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
        },
    },
    PARAGRAPH: {
        content: {
            textMarkupValue: '<p style="margin-top: 0; margin-bottom: 0;">Start typing here...</p>',
            align: 'left',
            fontFamily: 'Arial',
            fontSize: '16px',
            lineHeight: '24px',
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
        },
    },
    TABLE: {
        content: {
            textMarkupValue: `
            <table>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        `,
            align: 'center',
            fontSize: '16px',
        },
    },
    BUTTON: {
        content: {
            text: 'Button',
            href: '',
            align: 'center',
            fontFamily: 'Arial',
            fontSize: '16px',
            lineHeight: '16px',
            fontStyle: 'normal', // normal or italic
            fontWeight: 'normal', // normal or bold
            textDecoration: 'none',
            color: '#d3d3d3',
            backgroundColor: '#000000',
            borderRadius: 3,
            innerHorizontalPadding: 10,
            innerVerticalPadding: 10,
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
        },
    },
    SPACER: {
        // API doesn't currently support paddings for spacer element (attributes are on the docs but they don't work as expected if you try them)
        content: {
            containerBackgroundColor: '#CCCCCC',
            height: 10,
        },
    },
    SOCIAL: {
        content: {
            align: 'center',
            iconSize: 24,
            iconVersionColor: true,
            icons: [
                'instagram',
                'twitter',
                'youtube',
                'facebook',
                'email',
                'flickr',
                'glassdoor',
                'linkedin',
                'pinterest',
                'slack',
                'vimeo',
                'website',
                'wechat',
                'weibo',
                'workplace',
                'yammer',
                'microsoft-teams',
                'tiktok',
            ].map((item, index) => ({
                title: item,
                src: {
                    color: `https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-${item}.png`,
                    bw: `https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-${item}.png`,
                },
                href: '',
                active: index <= 3,
            })),
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
        },
    },
    SURVEY: {
        content: {
            type: rules.surveyTypes.SOCIAL_REACTION_EMOJI,
            iconSize: 28,
            surveyTitle: '',
            allowComments: false, // wether or not users can add additional comments after they submitted their survey response
            iconImages: {
                SOCIAL_REACTION_EMOJI: {
                    LOVE: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/love-1.png',
                    LIKE: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/like-1.png',
                    LAUGHING:
                        'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/laughing.png',
                    SURPRISE:
                        'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/surprise.png',
                    SAD: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/sad.png',
                    ANGRY: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/angry.png',
                },
                SOCIAL_REACTION_LIKE:
                    'https://app-data-legacy.bananatag.com/templates/images/surveys/pulse/new/thumbs_up.png',
                PULSE_RANGE_STARS:
                    'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/star.png',
                PULSE_RANGE_FACES: {
                    VERY_UNHAPPY:
                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/very-unhappy.png',
                    UNHAPPY:
                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/unhappy.png',
                    INDIFFERENT:
                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/indifferent.png',
                    HAPPY: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/happy.png',
                    VERY_HAPPY:
                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/very-happy.png',
                },
                PULSE_RANGE_NUMBERS: {
                    1: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/1.png',
                    2: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/2.png',
                    3: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/3.png',
                    4: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/4.png',
                    5: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/5.png',
                },
                PULSE_BINARY_THUMBS_UP_AND_DOWN: {
                    THUMBS_UP:
                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/thumbs_up.png',
                    THUMBS_DOWN:
                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/thumbs_down.png',
                },
                PULSE_BINARY_YES_AND_NO: {
                    YES: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/yes-square.png',
                    NO: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/no-square.png',
                },
                PULSE_BINARY_CHECKBOX_CONFIRM: {
                    YES: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/checked.png',
                    NO: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/unchecked.png',
                },
                ENPS: {
                    0: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/0.png',
                    1: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/1.png',
                    2: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/2.png',
                    3: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/3.png',
                    4: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/4.png',
                    5: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/5.png',
                    6: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/6.png',
                    7: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/7.png',
                    8: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/8.png',
                    9: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/9.png',
                    10: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/10.png',
                },
            },
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
        },
    },
    VIDEO: {
        content: {
            href: '',
            aspectRatio: null,
            playButtonColor: 'white',
            rawSource: '',
            alt: '',
            paddingTop: 10,
            paddingRight: 10,
            paddingLeft: 10,
            paddingBottom: 10,
        },
    },
};

const fonts = {
    PRIMARY_FONT: 'Arial',
    SECONDARY_FONT: 'Georgia',
};

export default {
    items,
    fonts,
    set updateItems(customizedItems) {
        const itemKeys = Object.keys(customizedItems);
        itemKeys.forEach((key) => {
            this.items[key] = customizedItems[key];
        });
    },
    set updateFonts({ primaryFont, secondaryFont }) {
        fonts.SECONDARY_FONT = secondaryFont;
        fonts.PRIMARY_FONT = primaryFont;
    },
};
